import "./main.css";
import Layout from "utils/layout";
import Video from "utils/video";
import FadeInElement from "utils/fadein";
import { getCookie, setCookie, eraseCookie } from "utils/cookies";
import { initLazyImages } from "utils/lazy-images";

const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === 1 && node.tagName.toLowerCase() === 'form-embed') {

        const form = node.shadowRoot?.querySelector('form');
        const form_id = node.parentElement.getAttribute('data-forms-id').replace('forms-root-', '');

        if (form) {
          form.addEventListener('submit', (e) => {
            if (!form.checkValidity()) {
              return;
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'bulk_form_submit',
              'form_id': form_id,
              'form_name': 'Bulk Gifting',
              'form_destination': 'shopify',
            });
          });
        }

        observer.disconnect();
      }
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

if (Shopify && Shopify.designMode) {
  document.addEventListener(`shopify:section:load`, (event) => {
    initialFunc();
    initLazyImages(event.target);
  });
}

if (window.TMW && window.TMW.debugger) {
  document.addEventListener("rivo:shopify:login", (event) => {
    location.reload();
  });
}

const toggleTransition = (sections) => {
  let fadeSectionsIndex = [];

  if (sections.length) {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.28,
    };

    const observer = new IntersectionObserver(handleIntersection, options);

    sections.forEach((section) => {
      section?.dataset?.transitionEnabled == "true" && observer.observe(section);
    });

    function handleIntersection(entries, observer) {
      entries.forEach(function (entry, index) {
        if (entry.isIntersecting) {
          entry.target.removeAttribute("data-scroll-transition");
        } else {
          if (!fadeSectionsIndex.includes(index) && index > 0) {
            entry.target.setAttribute("data-scroll-transition", "fade");
          }

          fadeSectionsIndex.push(index);
        }
      });
    }
  }
};

const initialFunc = () => {
  const uniq = (value, index, self) => self.indexOf(value) === index;
  const sections = document.querySelectorAll("[data-section]");
  const bottomSemicircle = document.getElementById("footer_semicircle");
  const sectionNames = [...sections]
    .map((section) => section.dataset.section)
    .filter(uniq);
  const layout = Layout.getInstance();
  FadeInElement.init();
  initLazyImages();

  sectionNames.forEach((name) => {
    import(/* webpackChunkName: "[index]" */ `./${name}/index.js`)
      .then((m) => {
        const module = m.default;
        const modules = [...sections].filter(
          (section) => section.dataset.section === name
        );
        modules.forEach((element) => {
          const dataEl = element.querySelector("[data-section-data]");
          const data = dataEl ? JSON.parse(dataEl.textContent) : {};
          const videoEls = element.querySelectorAll('[data-component="video"]');
          const videos =
            videoEls &&
            [...videoEls].map(
              (videoEl) => new Video({ element, video: videoEl, layout })
            );
          module(element, { ...data, layout, videos });
        });
      })
      // eslint-disable-next-line no-console
      .catch(console.error);
  });

  toggleTransition([...sections, bottomSemicircle]);
};
initialFunc();

/**
 * Enhanced User Identification
 * https://developers.applovin.com/en/audience-plus/google-tag-manager#enhanced-user-identification-recommended
 *
 */
const ehancedUserIdentification = () => {
  if (location.protocol !== "https:") {
    return;
  }

  const appLovinCookieName = "_axwrt";
  const appLovinCookieNewName = "axwrt";
  const appLovinCookie = getCookie(appLovinCookieName);

  if (appLovinCookie === null) {
    return;
  }

  // Set new cookie for one year
  setCookie(appLovinCookieNewName, appLovinCookie, 365, "Lax");
};

ehancedUserIdentification();
